import { AxiosResponse, CancelToken } from "axios";
import http from "../../../../shared/http";
import { qs } from "../../../../utils";
import {
  ReadSupplementsGroupsRequestDto,
  ReadSupplementsGroupsResponseDto,
} from "./dtos";

export const listSupplementsGroups = async (
  { _query, instances }: ReadSupplementsGroupsRequestDto,
  cancelToken: CancelToken
): Promise<AxiosResponse<ReadSupplementsGroupsResponseDto>> => {
  const query = qs.stringify(_query);
  return await http.post<ReadSupplementsGroupsResponseDto>(
    `/supplement-categories${query}`,
    {
      _method: "GET",
      instances,
    },
    { cancelToken }
  );
};
